import axios from '../config.js';
const resource = '/case/consultation';

export default {
  get(id=null, doctor=null, today=null, status=null, page=null) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('auth_token')}`;
    const params = new URLSearchParams();
    if (doctor) params.append('own_case_only', '');
    if (today)  params.append('today_only', '');
    if (status) params.append('status', status);
    if (page) params.append('page', page);

    if (id) {
      return axios.get(`consultation_data_only/${id}`);
    } else {
      return axios.get(`${resource}`, { params: params });
    }
    
  },


  update(id="", payload) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('auth_token')}`
    var data = {
      _method: 'PUT',
      ...payload
    }

    return axios.post(`${resource}${id ? `/${id}`: ''}`, data);
  }
};